import { httpRequest } from '@/utils/request';
import { TableReponseType, CommonResponse } from '@/types';

export interface CategoryItem {
  id: string;
  name: string;
  image_url: string;
  sort_order: number;
  children: CategoryItem[];
}

export function categoryTemplate<T>(params: { category_name: string }) {
  return httpRequest<any, CommonResponse<TableReponseType<T>>, { category_name: string }>({
    url: '/api/v1/category-template',
    params,
  });
}
export function getCategoryTemplate<T>(params: { id: string }) {
  return httpRequest<any, CommonResponse<T>, { id: string }>({
    url: `/api/v1/category-template/${params.id}`,
    params,
  });
}

export function getAllCategories() {
  return httpRequest<any, CommonResponse<CategoryItem[]>>({
    url: '/api/v1/solution/category/all',
    method: 'GET',
  });
}

// 获取解决方案产品列表
export function getSolutionProducts(params?: { name?: string }) {
  return httpRequest<any, CommonResponse<CategoryItem[]>, { name?: string }>({
    url: '/api/v1/solution/product',
    method: 'GET',
    params,
  });
}

// 搜索分类（支持name参数）
export function searchCategories(params: { name: string }) {
  return httpRequest<any, CommonResponse<CategoryItem[]>, { name: string }>({
    url: '/api/v1/solution/category/all',
    method: 'GET',
    params,
  });
}

export interface ThingModelItem {
  id: string;
  product_id?: string;
  type: 'property' | 'event' | 'action';
  name: string;
  code: string;
  type_spec?: {
    type: string;
    specs: string;
  };
  access_mode?: string;
  description?: string;
  tag?: string;
  system?: boolean;
  external?: any;
  sort?: number;
  storage_mode?: number;
  created?: number;
  modified?: number;
}

export interface CategoryThingModelResponse {
  id: string;
  name: string;
  image_url: string;
  sort_order: number;
  properties: ThingModelItem[];
  events: ThingModelItem[];
  actions: ThingModelItem[];
}

export function getCategoryThingModel(solutionId: string) {
  return httpRequest<any, CommonResponse<CategoryThingModelResponse>>({
    url: `/api/v1/solution/category/${solutionId}`,
    method: 'GET',
  });
}

// 添加标准产品物模型
export function addThingModelTemplate(data: any) {
  return httpRequest<any, CommonResponse<any>>({
    url: '/api/v1/solution/thingmodel/template',
    method: 'POST',
    data,
  });
}

// 修改标准产品物模型
export function putThingModelTemplate(data: any) {
  return httpRequest<any, CommonResponse<any>>({
    url: '/api/v1/solution/thingmodel/template',
    method: 'PUT',
    data,
  });
}

// 删除标准产品物模型
export function deleteThingModelTemplate(data: { thing_model_id: string; thing_model_type: string }) {
  return httpRequest<any, CommonResponse<any>>({
    url: '/api/v1/solution/thingmodel/template',
    method: 'DELETE',
    data,
  });
}
